export const OA_APP_ROOT = '/oncoagent/app';

export function oaAppPath(segment = ''): string {
  if (!segment || segment === '/') return OA_APP_ROOT;
  const rest = segment.startsWith('/') ? segment : `/${segment}`;
  return `${OA_APP_ROOT}${rest}`;
}
